var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"template-name-position"},[_c('h1',[_vm._v(" "+_vm._s(_vm.candidate.name)+" ")]),_c('h2',[_vm._v("For "+_vm._s(_vm.setPosition(_vm.candidate.positionId)))])])}
var staticRenderFns = []

export { render, staticRenderFns }